module.exports = __webpack_public_path__ + "static/media/ipause.ebff3ab3.svg";